import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { api, formatApiError } from "@/lib/api";
import { toast } from "sonner";

export default function NewPaymentDialog({ open, onOpenChange, defaultClientId, onCreated }) {
  const [clients, setClients] = useState([]);
  const [form, setForm] = useState({
    client_id: defaultClientId || "",
    amount: "",
    currency: "TRY",
    status: "beklemede",
    due_date: "",
    description: "Aylık danışmanlık ücreti",
  });
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!open) return;
    api.get("/clients").then((r) => setClients(r.data));
    setForm((prev) => ({ ...prev, client_id: defaultClientId || prev.client_id }));
    // eslint-disable-next-line
  }, [open, defaultClientId]);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.client_id) {
      toast.error("Danışan seçin");
      return;
    }
    setBusy(true);
    try {
      const payload = { ...form, amount: parseFloat(form.amount) };
      if (payload.due_date) payload.due_date = new Date(payload.due_date).toISOString();
      const { data } = await api.post("/payments", payload);
      toast.success("Ödeme oluşturuldu");
      onCreated && onCreated(data);
      onOpenChange(false);
      setForm({ client_id: defaultClientId || "", amount: "", currency: "TRY", status: "beklemede", due_date: "", description: "Aylık danışmanlık ücreti" });
    } catch (e2) {
      toast.error(formatApiError(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="new-payment-dialog">
        <DialogHeader>
          <DialogTitle>Yeni Ödeme</DialogTitle>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div>
            <label className="block text-[11px] uppercase tracking-wider text-pleiades-slate mb-1">Danışan *</label>
            <select
              required
              value={form.client_id}
              onChange={(e) => setForm({ ...form, client_id: e.target.value })}
              data-testid="new-payment-client"
              className="w-full h-9 px-2 border border-pleiades-border rounded-sm text-[13px] bg-white"
            >
              <option value="">Seçin…</option>
              {clients.map((c) => (
                <option key={c.id} value={c.id}>{c.full_name}</option>
              ))}
            </select>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <label className="block text-[11px] uppercase tracking-wider text-pleiades-slate mb-1">Tutar *</label>
              <input
                type="number"
                required
                step="0.01"
                min="0"
                value={form.amount}
                onChange={(e) => setForm({ ...form, amount: e.target.value })}
                data-testid="new-payment-amount"
                className="w-full h-9 px-3 border border-pleiades-border rounded-sm text-[13px]"
              />
            </div>
            <div>
              <label className="block text-[11px] uppercase tracking-wider text-pleiades-slate mb-1">Durum</label>
              <select
                value={form.status}
                onChange={(e) => setForm({ ...form, status: e.target.value })}
                data-testid="new-payment-status"
                className="w-full h-9 px-2 border border-pleiades-border rounded-sm text-[13px] bg-white"
              >
                <option value="beklemede">Beklemede</option>
                <option value="odendi">Ödendi</option>
                <option value="iptal">İptal</option>
              </select>
            </div>
          </div>
          <div>
            <label className="block text-[11px] uppercase tracking-wider text-pleiades-slate mb-1">Vade</label>
            <input
              type="datetime-local"
              value={form.due_date}
              onChange={(e) => setForm({ ...form, due_date: e.target.value })}
              data-testid="new-payment-due"
              className="w-full h-9 px-3 border border-pleiades-border rounded-sm text-[13px]"
            />
          </div>
          <div>
            <label className="block text-[11px] uppercase tracking-wider text-pleiades-slate mb-1">Açıklama</label>
            <input
              value={form.description}
              onChange={(e) => setForm({ ...form, description: e.target.value })}
              className="w-full h-9 px-3 border border-pleiades-border rounded-sm text-[13px]"
            />
          </div>
          <DialogFooter className="pt-2">
            <button type="button" onClick={() => onOpenChange(false)} className="h-9 px-3 border border-pleiades-border rounded-sm text-[13px] hover:bg-pleiades-sidebar">
              Vazgeç
            </button>
            <button type="submit" disabled={busy} data-testid="new-payment-submit" className="h-9 px-3 bg-pleiades-blue hover:bg-pleiades-blue-hover text-white text-[13px] rounded-sm disabled:opacity-50">
              {busy ? "Kaydediliyor…" : "Ödeme Kaydet"}
            </button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
